import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import * as Utils from '../../utils';

class MoveIcon extends Component {
  constructor(props) {
    super(props);
    this.handleOrderAddition = this.handleOrderAddition.bind(this);
  }

  handleOrderAddition() {
    const {order, orders, provider, partType} = this.props;
    const repeatedIndex = Utils.getRepeatedIndex(orders, order.partCode);

    if (repeatedIndex !== -1) {
      this.props.addMessageBoxError(
        `El código ${order.partCode} se repite en la línea ${repeatedIndex + 1} del pedido sin filtrar.`
      );
      return;
    }

    this.props.checkProviderStockOrderCode(order, {provider, 'type': 'move'}, {partType});
  }

  render() {
    return (
      <Icon link
        size='large'
        name='add'
        onClick={this.handleOrderAddition}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'orders': state.providerStockOrders.suggestedOrders,
    'provider': state.providerStockOrders.provider,
    'partType': state.providerStockOrders.partType,
  };
};

const {
  addMessageBoxError,
  checkProviderStockOrderCode,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  checkProviderStockOrderCode,
})(MoveIcon);
